import * as React from 'react';
import ScaledValue, { ScaledValueProps } from './ScaledValue';

type Props = {
  bytes: number;
};

export default class ScaledBytes extends React.Component<
  Props & ScaledValueProps
> {
  render() {
    const { bytes, ...rest } = this.props;
    return <ScaledValue value={bytes} base={1024} {...rest} />;
  }
}
